import { MenuProps } from '../types/menu';
import { atom, useAtom } from 'jotai';

// initial state
const initialState: MenuProps = {
	openItem: ['dashboard'],
	openComponent: 'buttons',
	selectedID: null,
	drawerOpen: false,
	menu: {},
};

const menuAtom = atom<MenuProps>(initialState);

type ReturnType = Readonly<{
	state: MenuProps;
	activeItem: (openItem: string[]) => void;
	activeId: (selectedId: string | null) => void;
	openDrawer: (drawerOpen: boolean) => void;
}>;

export const useMenu = (): ReturnType => {
	const [state, setState] = useAtom(menuAtom);

	const activeItem = (openItem: string[]) => setState({ ...state, openItem });

	const activeId = (selectedID: string | null) => setState({ ...state, selectedID });

	const openDrawer = (drawerOpen: boolean) => setState({ ...state, drawerOpen });

	return { state, activeItem, activeId, openDrawer };
};
